module.exports = __webpack_public_path__ + "img/26.ef7c2c79.jpg";